(function () {
  if (window.cherryLookbookLoaded) return;
  window.cherryLookbookLoaded = true;

  const sectionSelector = '[data-cherry-lookbook]';

  class CherryLookbook {
    constructor(section) {
      this.section = section;
      this.cards = Array.from(section.querySelectorAll('[data-lookbook-card]'));
      this.filterButtons = Array.from(section.querySelectorAll('[data-lookbook-filter]'));
      this.loadPanel = section.querySelector('[data-lookbook-load-panel]');
      this.loadButton = section.querySelector('[data-lookbook-load]');
      this.status = section.querySelector('[data-lookbook-status]');
      this.initialCount = Number.parseInt(section.dataset.initialCount, 10) || 5;
      this.activeFilter = 'all';
      this.expanded = false;

      this.bindEvents();
      this.render(false);
    }

    bindEvents() {
      this.filterButtons.forEach((button) => {
        button.addEventListener('click', () => {
          this.activeFilter = button.dataset.lookbookFilter || 'all';
          this.expanded = false;
          this.render(true);
        });
      });

      if (this.loadButton) {
        this.loadButton.addEventListener('click', () => {
          this.expanded = true;
          this.render(true);
        });
      }
    }

    matchesActiveFilter(card) {
      return this.activeFilter === 'all' || card.dataset.category === this.activeFilter;
    }

    render(announce) {
      const matchingCards = this.cards.filter((card) => this.matchesActiveFilter(card));
      const visibleCards = this.expanded
        ? matchingCards
        : matchingCards.slice(0, this.initialCount);
      const visibleSet = new Set(visibleCards);

      this.cards.forEach((card) => {
        card.hidden = !visibleSet.has(card);
        card.classList.remove('is-featured', 'is-extra');
      });

      visibleCards.forEach((card, index) => {
        if (index === 0) card.classList.add('is-featured');
        if (index >= this.initialCount) card.classList.add('is-extra');
      });

      this.filterButtons.forEach((button) => {
        const isActive = button.dataset.lookbookFilter === this.activeFilter;
        button.classList.toggle('is-active', isActive);
        button.setAttribute('aria-pressed', String(isActive));
      });

      const hasMore = !this.expanded && matchingCards.length > this.initialCount;
      this.section.classList.toggle('has-load-more', hasMore);

      if (this.loadPanel) this.loadPanel.hidden = !hasMore;

      if (announce && this.status) {
        this.status.textContent = `Showing ${visibleCards.length} of ${matchingCards.length} collections.`;
      }
    }
  }

  function initializeLookbooks(root) {
    const sections = root.matches && root.matches(sectionSelector)
      ? [root]
      : Array.from(root.querySelectorAll(sectionSelector));

    sections.forEach((section) => {
      if (section.dataset.lookbookInitialized === 'true') return;
      section.dataset.lookbookInitialized = 'true';
      new CherryLookbook(section);
    });
  }

  function initialize() {
    initializeLookbooks(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initializeLookbooks(event.target);
  });
})();
